import axios from 'axios'
import { DESBLOQUEAR_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idEmpresa) => dispach =>
  axios.get(`${URL}/empresas/${idEmpresa}/desbloquear`,SLOW_REQUEST_CONFIG)
    .then( reponse => dispach({
        type: DESBLOQUEAR_EMPRESA,
        payload: reponse
  }));
